import { AppState } from "@Store/index";
import { shallowEqual, useSelector } from "react-redux";
import getCookie from "helpers/getCookie";

const useShowGridView = () => {
  const { showGridView } = useSelector(
    ({ appData }: AppState) => ({
      showGridView: appData.showGridView,
    }),
    shallowEqual,
  );
  if (typeof window !== "undefined") {
    const cookieValue = getCookie("search_grid_view");
    if (cookieValue === "true") return true;
    if (cookieValue === "false") return false;
  }
  return showGridView;
};

export default useShowGridView;
